/**
 * Sleuth mark — an S monogram with a waveform inside, set on a deep
 * teal-on-charcoal squircle (design-language.md §Mark). Renders cleanly
 * from 16px (favicon) up to hero-scale.
 *
 * The S is a curved path through the squircle; the waveform is a sparser
 * stroke that intersects the S. No glow, no neon, no sharp angles.
 */
export function SleuthMark({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="LagSleuth mark"
      className={className}
    >
      <defs>
        <linearGradient id="sleuth-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1A2630" />
          <stop offset="100%" stopColor="#0E1318" />
        </linearGradient>
      </defs>
      {/* Squircle */}
      <rect
        x="2"
        y="2"
        width="60"
        height="60"
        rx="16"
        ry="16"
        fill="url(#sleuth-bg)"
        stroke="#5EBFB8"
        strokeOpacity="0.32"
        strokeWidth="1.25"
      />
      {/* Waveform — a sparser stroke beneath the S */}
      <path
        d="M 12 38 Q 18 30, 24 38 T 36 38 T 48 38 T 52 38"
        fill="none"
        stroke="#5EBFB8"
        strokeOpacity="0.45"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* S monogram — curve through the squircle */}
      <path
        d="M 44 22 Q 38 18, 30 20 Q 22 22, 22 28 Q 22 33, 30 34 L 36 35 Q 44 36, 44 42 Q 44 48, 34 48 Q 26 48, 20 44"
        fill="none"
        stroke="#5EBFB8"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
